<template>
    <div id="Search">
        <van-cell is-link>
          <template slot="title">
            <span class="custom-title">学年：</span>
          </template>
          <van-field
            slot="default"
            placeholder="请选择学年"
            @click.stop="yearShow" v-model="yearName" readonly
          />
          <van-popup
            v-model="isYearShow"
            position="bottom"
            :style="{ height: '50%' }"
          >
            <van-cell
              v-for="item in yearList"
              :key="item.id"
              :title="item.label"
              class="text-center"
               @click="item.callback(item)"
            />
          </van-popup>
        </van-cell>
        
        <van-cell is-link class="marginTop">
          <template slot="title">
            <span class="custom-title">学期：</span>
          </template>
          <van-field
            slot="default"
            placeholder="请选择学期"
            @click.stop="sessionShow" v-model="sessionName" readonly
          />
          <van-popup
            v-model="isSessionShow"
            position="bottom"
            :style="{ height: '50%' }"
          >
            <van-cell
              v-for="item in sessionList"
              :key="item.id"
              :title="item.label"
              class="text-center"
               @click="item.callback(item)"
            />
          </van-popup>
        </van-cell>
        
        <van-cell is-link class="marginTop">
          <template slot="title">
            <span class="custom-title">校区：</span>
          </template>
          <van-field
            slot="default"
            placeholder="请选择校区"
            @click.stop="schoolShow" v-model="schoolData.Name" readonly
          />
          <van-popup
            v-model="schoolData.IsShow"
            position="bottom"
            :style="{ height: '50%' }"
          >
            <van-cell
              v-for="item in schoolData.List"
              :key="item.id"
              :title="item.label"
              class="text-center"
               @click="item.callback(item)"
            />
          </van-popup>
        </van-cell>
        
        <van-cell is-link class="marginTop">
          <template slot="title">
            <span class="custom-title">学届：</span>
          </template>
          <van-field
            slot="default"
            placeholder="请选择学届"
            @click.stop="studentYearShow" v-model="studentYearData.Name" readonly
          />
          <van-popup
            v-model="studentYearData.IsShow"
            position="bottom"
            :style="{ height: '50%' }"
          >
            <van-cell
              v-for="item in studentYearData.List"
              :key="item.id"
              :title="item.label"
              class="text-center"
               @click="item.callback(item)"
            />
          </van-popup>
        </van-cell>
        
        <van-cell is-link class="marginTop">
          <template slot="title">
            <span class="custom-title">学习阶段：</span>
          </template>
          <van-field
            slot="default"
            placeholder="请选择学习阶段"
            @click.stop="studentGradeShow" v-model="studentGradeData.Name" readonly
          />
          <van-popup
            v-model="studentGradeData.IsShow"
            position="bottom"
            :style="{ height: '50%' }"
          >
            <van-cell
              v-for="item in studentGradeData.List"
              :key="item.id"
              :title="item.label"
              class="text-center"
               @click="item.callback(item)"
            />
          </van-popup>
        </van-cell>

        <van-cell is-link class="marginTop">
          <template slot="title">
            <span class="custom-title required">考试：</span>
          </template>
          <van-field
            slot="default"
            placeholder="请选择考试"
            @click.stop="examShow" v-model="examData.Name" readonly
          />
          <van-popup
            v-model="examData.IsShow"
            position="bottom"
            :style="{ height: '50%' }"
          >
            <van-cell
              v-for="item in examData.List"
              :key="item.id"
              :title="item.label"
              class="text-center"
               @click="item.callback(item)"
            />
          </van-popup>
        </van-cell>

        <van-button type="info" :loading="loading" loading-text="查询中..." size="large" color="#4899fb" @click.native="search">查询</van-button>
    </div>
</template>
<script>
export default {
  data() {
    return {
        apiPath: "/api/AchievementAnalysis/",
        loading: false,//保存中状态
        //学年
        isYearShow: false,
        yearName: '',
        yearID: '',
        yearList: [],
        //学期
        isSessionShow: false,
        sessionName: '',
        sessionID: '',
        sessionList: [],


        //校区
        schoolData: {
            IsShow: false,
            Name: '',
            ID: '',
            List: [],
        },

        //学届
        studentYearData: {
            IsShow: false,
            Name: '',
            ID: '',
            List: [],
        },

        //学习阶段
        studentGradeData: {
            IsShow: false,
            Name: '',
            ID: '',
            List: [],
        },

        //
        examData: {
            IsShow: false,
            Name: '',
            ID: '',
            List: [],
        },
    };
  },
  components: {},
  created: function() {
        this.getYears();
        this.getSchools();
  },
  mounted: function() {
    
  },
  methods: {
        yearShow: function () {
            if (this.yearList.length > 0) {
                this.isYearShow = true;
            } else {
                this.xy.msgInfo('暂无学年');
            }
        },
        async getYears () {//获取学年
          let res = await this.xyapi.get(
            this.xyMApi + '/xy/comm/YearList'
          );
          let self= this;
          if (res&&!res.success) {
              this.xy.msgInfo(res.msg);
          } else {
              if (res&&res.data.length > 0) {
                res.data.forEach((item)=>{
                  // this.yearList.push(item.Name)
                  this.yearList.push({
                      id: item.ID,
                      label: item.Name,
                      callback: function (e) {
                        console.log(e)
                          self.yearName = e.label;
                          self.yearID = e.id;
                          //选择校区时把联动的场馆置空
                          self.sessionID = "";
                          self.sessionName = "";
                          self.isYearShow = false;
                          self.getSession(e.id);
                      }
                  });
                })
              }
          }
        },

        sessionShow: function () {
            if (this.sessionList.length > 0) {
                this.isSessionShow = true;
            } else {
              this.xy.msgInfo('暂无学期');
            }
        },
        async getSession (yearID) {//获取学期
          let res = await this.xyapi.get(
            this.xyMApi + '/xy/comm/SessionList',{yearID: yearID}
          );
          let self= this;
          if (!res.success) {
              this.xy.msgInfo(res.msg);
          } else {
              if (res.data.length > 0) {

                res.data.forEach((item)=>{
                  this.sessionList.push({
                      id: item.AcademicSessionID,
                      label: item.AcademicSessionName,
                      callback: function (e) {
                          self.isSessionShow = false;
                          self.sessionName = e.label;
                          self.sessionID = e.id;
                          self.getExams();
                      }
                  });
                })
              }
          }
        },


        schoolShow: function () {
            
            if (this.schoolData.List.length > 0) {
                this.schoolData.IsShow = true;
            } else {
              this.xy.msgInfo('暂无校区');
            }
        },
        async getSchools () {
          let res = await this.xyapi.get(
            this.xyMApi + '/xy/comm/SchoolDistrictList',
          );
          let self = this;
          if (!res.success) {
            this.xy.msgInfo(res.msg);
          } else {
              if (res.data.length > 0) {
                res.data.forEach((item)=>{
                  this.schoolData.List.push({
                      id: item.SchoolDistrictID,
                      label: item.SchoolDistrictName,
                      callback: function (e) {
                          self.schoolData.Name = e.label;
                          self.schoolData.ID = e.id;
                          self.schoolData.IsShow = false;
                          //选择校区时
                          self.studentYearData.ID = "";
                          self.studentYearData.Name = "";
                          self.studentGradeData.ID = "";
                          self.studentGradeData.Name = "";
                          self.getstudentYears(e.id);
                      }
                  });
                })
              }
          }
        },

        studentYearShow: function () {
            
            if (this.studentYearData.List.length > 0) {
                this.studentYearData.IsShow = true;
            } else {
              this.xy.msgInfo('暂无学届');
            }
        },
        async getstudentYears (schoolId) {
          let res = await this.xyapi.get(
            this.xyMApi + '/xy/comm/StudentYearList',{
                schoolID: schoolId
            }
          );
          let self = this;
          if (!res.success) {
             this.xy.msgInfo(res.msg);
          } else {
              if (res.data.length > 0) {
                res.data.forEach((item)=>{
                  this.studentYearData.List.push({
                      id: item.StudentYearID,
                      label: item.StudentYearName,
                      callback: function (e) {
                          self.studentYearData.Name = e.label;
                          self.studentYearData.ID = e.id;
                          self.studentYearData.IsShow = false;
                          self.studentGradeData.ID = "";
                          self.studentGradeData.Name = "";
                          self.getstudentGrades(schoolId, e.id);
                      }
                  });
                })
              }
          }
        },

        studentGradeShow: function () {
            
            if (this.studentGradeData.List.length > 0) {
                this.studentGradeData.IsShow = true;
            } else {
                this.xy.msgInfo('暂无学习阶段');
            }
        },
        async getstudentGrades (schoolId, studentYearId) {
          let res = await this.xyapi.get(
            this.xyMApi + '/xy/comm/StudentGradeList', {
                schoolID: schoolId,
                studentYearID: studentYearId
            }
          );
          let self = this;
          if (res&&!res.success) {
              this.xy.msgInfo(res.msg);
          } else {
            if (res&&res.data.length > 0) {
              res.data.forEach((item)=>{
                this.studentGradeData.List.push({
                    id: item.StudentGradeID,
                    label: item.StudentGradeName,
                    callback: function (e) {
                        self.studentGradeData.Name = e.label;
                        self.studentGradeData.ID = e.id;
                        self.studentGradeData.IsShow = false;
                        self.getExams();
                    }
                });
              })
            }
          }
        },


        examShow: function () {
            
            if (this.examData.List.length > 0) {
                this.examData.IsShow = true;
            } else {
              this.xy.msgInfo('暂无考试');
            }
        },
        async getExams () {
          let res = await this.xyapi.get(
            this.$store.state.apiPath + this.apiPath +'GetAnalyseAchievementRInfo',{
                academicYearID: this.yearID || 0,//学年
                academicSessionID: this.sessionID || 0,//学期
                schoolDistrictID: this.schoolData.ID || 0,//校区
                studentYearID: this.studentYearData.ID || 0,//学届
                studentGradeID: this.studentGradeData.ID || 0,//学习阶段
            }
          );
          if (res&&!res.success) {
            this.xy.msgInfo(res.msg);
          } else {
            if (res&&res.data.data.length > 0) {
              res.data.data.forEach((item)=>{
                this.examData.List.push({
                    id: item.AchievementRecordID,
                    label: item.AchievementRecordName,
                    callback: function (e) {
                        this.examData.Name = e.label;
                        this.examData.ID = e.id;
                    }
                });
              })
            }
          }
        },


        // //查询
        search: function () {
            
            if (this.examData.ID < 1) {
               this.xy.msgError('请选择考试');
              return false;
            }

            this.loading = true;
            let rowData = JSON.stringify({"examId": this.examData.ID})
            this.$router.push({path: '/home/AchievementAnalysis', query:{rowData:rowData}})
        }
  }
};
</script>
<style lang='less' >
  #Search{
    .van-cell{
      color: #333;
    }
    
    .van-cell__title {
      flex: none; 
    }
    .van-cell__value{
      text-align: left;
    }
    .van-cell__right-icon{
      float: right;
    }
    .van-field{
      padding: 0;
    }
    .van-field__control{
      height: 50px;
      color: #555;
    }
    input[type=text]::-webkit-input-placeholder { 
      color: #555;
      font-size: 28px;
      font-family: tahoma, 宋体, arial;
    }
    .van-cell:not(:last-child):after{
      border: none;
    }
    .text-center{
      text-align: center;
      .van-cell__title{
        flex: 1
      }
    }
    .marginTop{
      margin-top: 20px;
    }
    .required:before {
      content: "*";
      color: red;
      margin-right: 5px;
      vertical-align: sub;
    }
    .van-button{
      height: 90px;
      line-height: 90px;
      margin-top: 50px;
      font-size: 30px;
      font-family: tahoma, 宋体, arial;
    }
  }
</style>